const PRESET_COLOR_KEY = 'template-preset-colors';
const MAX_PRESET_ITEMS = 10;

function getPresetColorsKey(templateId) {
  return `${PRESET_COLOR_KEY}-${templateId}`;
}

function colorInList(list, color) {
  return list.indexOf(color) !== -1;
}

function exceedsMaxListSize(list) {
  return list.length >= MAX_PRESET_ITEMS;
}

function setItem(templateId, data) {
  const presetColorKey = getPresetColorsKey(templateId);
  return localStorage.setItem(presetColorKey, JSON.stringify(data));
}

function getItem(templateId) {
  const presetColorKey = getPresetColorsKey(templateId);
  return localStorage.getItem(presetColorKey);
}

export function getPresetColors(templateId) {
  const presetColors = getItem(templateId);
  if (presetColors) {
    return JSON.parse(presetColors);
  }
  return [];
}

export function addPresetColors(templateId, color) {
  const hexColor = `#${color.hex}`;
  const presetColors = getPresetColors(templateId);
  if (colorInList(presetColors, hexColor)) {
    return false;
  }
  if (exceedsMaxListSize(presetColors)) {
    presetColors.pop();
  }
  setItem(templateId, [hexColor].concat(presetColors));
}

export function setPresetColors(templateId, colors) {
  setItem(templateId, colors);
}
